import { Icon } from '@zenid/web';
import { css } from '../../../../../styled-system/css';
import { flex } from '../../../../../styled-system/patterns';
import { PastOrganizations } from './PastOrganizations';
import type { CurrentOrganizationsProps } from './CurrentOrganizations/CurrentOrganizations';
import { CurrentOrganizations } from './CurrentOrganizations/CurrentOrganizations';
import type { PastOrganizationsProps } from './PastOrganizations/PastOrganizations';
import { shouldShowOrganizations } from './shouldShowOrganizations';

type OrganizationsProps = Pick<CurrentOrganizationsProps, 'currentMemberships'> &
  Pick<PastOrganizationsProps, 'pastMemberships'>;

export function Organizations({ currentMemberships, pastMemberships }: OrganizationsProps) {
  // 過去現在問わずmembershipsを見て所属情報の表示有無を判断する
  const showOrganizations = shouldShowOrganizations([...currentMemberships, ...pastMemberships]);
  return (
    <div className={flex({ minWidth: '343px', flexDirection: 'column', sm: { maxWidth: '720px' } })}>
      <div
        className={flex({
          flexDirection: 'row',
          alignItems: 'center',
          gap: '{spacing.4}',
          marginBottom: '{spacing.20}',
        })}
      >
        <Icon name="badge" color="colors.text.main" size="m" />
        <h2 className={css({ textStyle: 'headding.s', sm: { textStyle: 'headding.l' } })}>所属情報</h2>
      </div>
      <CurrentOrganizations showOrganizations={showOrganizations} currentMemberships={currentMemberships} />
      <PastOrganizations showOrganizations={showOrganizations} pastMemberships={pastMemberships} />
    </div>
  );
}
